// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 767px) {
	.mobilehidden {
		display: none;
	}
}

.ValidateCssUpdateV1_2 {
	display: none;
}

.contentbreakerblock {
	width: 100%;
	float: none;
	clear: both;
}

.block {
	word-wrap:break-word;
    float:left;
    width:100%;
}
.block.pull-right {
	float:right;
}
@media screen and (min-width: 768px){
    .block.col-sm-4 { width: 33.33333% !important; }
    .block.col-sm-6 { width: 50% !important;}
    .block.col-sm-8 { width: 66.66667% !important; }    
}

.epi-editContainer {
    float:left;
    width: 100%;
}

.section-header-fix {
    /*margin-top: -7px;*/
}

/*.sectionblock-border { border: 1px solid #7f8f90;}*/
    /*.sectionblock-background {background: #ccc;}*/
    .globalalert-container {
	position: absolute;
}

.globalalert-container > .alert {
	margin-bottom: 0;
	text-align: left;
}

.temper-temper {
	margin-top: 35px;
}

table thead>tr>th.colheader-sortable { 
	cursor: pointer;
	position: relative;
	padding-right: 30px;
}

table .colheader-sortable.colheader-unsorted:after {
	opacity: .2;
	content: "\\E150";
}

table .colheader-sortable.colheader-sorted-asc:after {
	content: "\\E155";
} 

table .colheader-sortable.colheader-sorted-desc:after {
	content: "\\E156";
}

.selected-sort {
	font-weight: bold;
}

table .colheader-sortable:after {
    position: absolute;
    bottom: 8px;
    right: 8px;
    display: block;
    font-family: Glyphicons Halflings;
    opacity: .5;
}

a.searchsort {
	text-decoration: none;
}

.sort-orderable:after {
	opacity: .2;
	content: "\\E150";
}

.sort-orderable {
	padding-right: 25px;
}

.selected-sort.sort-orderable.sorted-ASC:after {
	content: "\\E155";
} 

.selected-sort.sort-orderable.sorted-DESC:after {
	content: "\\E156";
}

.sort-orderable:after {
    position: absolute;
    top: 25px;
    right: 20px;
    display: block;
    font-family: Glyphicons Halflings;
    opacity: .5;
}

.disabledElement {
    pointer-events: none;
    opacity: 0.4;
}`, "",{"version":3,"sources":["webpack://./css/integrate.css"],"names":[],"mappings":"AAAA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,oBAAoB;IACjB,UAAU;IACV,UAAU;AACd;AACA;CACC,WAAW;AACZ;AACA;IACI,kBAAkB,2BAA2B,EAAE;IAC/C,kBAAkB,qBAAqB,CAAC;IACxC,kBAAkB,2BAA2B,EAAE;AACnD;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA,qDAAqD;IACjD,+CAA+C;IAC/C;CACH,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;IACd,iCAAiC;IACjC,WAAW;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB","sourcesContent":["@media (max-width: 767px) {\n\t.mobilehidden {\n\t\tdisplay: none;\n\t}\n}\n\n.ValidateCssUpdateV1_2 {\n\tdisplay: none;\n}\n\n.contentbreakerblock {\n\twidth: 100%;\n\tfloat: none;\n\tclear: both;\n}\n\n.block {\n\tword-wrap:break-word;\n    float:left;\n    width:100%;\n}\n.block.pull-right {\n\tfloat:right;\n}\n@media screen and (min-width: 768px){\n    .block.col-sm-4 { width: 33.33333% !important; }\n    .block.col-sm-6 { width: 50% !important;}\n    .block.col-sm-8 { width: 66.66667% !important; }    \n}\n\n.epi-editContainer {\n    float:left;\n    width: 100%;\n}\n\n.section-header-fix {\n    /*margin-top: -7px;*/\n}\n\n/*.sectionblock-border { border: 1px solid #7f8f90;}*/\n    /*.sectionblock-background {background: #ccc;}*/\n    .globalalert-container {\n\tposition: absolute;\n}\n\n.globalalert-container > .alert {\n\tmargin-bottom: 0;\n\ttext-align: left;\n}\n\n.temper-temper {\n\tmargin-top: 35px;\n}\n\ntable thead>tr>th.colheader-sortable { \n\tcursor: pointer;\n\tposition: relative;\n\tpadding-right: 30px;\n}\n\ntable .colheader-sortable.colheader-unsorted:after {\n\topacity: .2;\n\tcontent: \"\\E150\";\n}\n\ntable .colheader-sortable.colheader-sorted-asc:after {\n\tcontent: \"\\E155\";\n} \n\ntable .colheader-sortable.colheader-sorted-desc:after {\n\tcontent: \"\\E156\";\n}\n\n.selected-sort {\n\tfont-weight: bold;\n}\n\ntable .colheader-sortable:after {\n    position: absolute;\n    bottom: 8px;\n    right: 8px;\n    display: block;\n    font-family: Glyphicons Halflings;\n    opacity: .5;\n}\n\na.searchsort {\n\ttext-decoration: none;\n}\n\n.sort-orderable:after {\n\topacity: .2;\n\tcontent: \"\\E150\";\n}\n\n.sort-orderable {\n\tpadding-right: 25px;\n}\n\n.selected-sort.sort-orderable.sorted-ASC:after {\n\tcontent: \"\\E155\";\n} \n\n.selected-sort.sort-orderable.sorted-DESC:after {\n\tcontent: \"\\E156\";\n}\n\n.sort-orderable:after {\n    position: absolute;\n    top: 25px;\n    right: 20px;\n    display: block;\n    font-family: Glyphicons Halflings;\n    opacity: .5;\n}\n\n.disabledElement {\n    pointer-events: none;\n    opacity: 0.4;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
